var _rect, _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DZone4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 869,
    y: 457,
    width: 103.87,
    height: 23.51,
    rx: 11.755,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M891.75 474.255V473.232L898.023 463.869H891.682V462.619H899.704V463.641L893.432 473.005H899.773V474.255H891.75ZM911.888 468.437C911.888 469.664 911.666 470.725 911.223 471.619C910.78 472.513 910.172 473.202 909.399 473.687C908.626 474.172 907.744 474.414 906.751 474.414C905.759 474.414 904.876 474.172 904.103 473.687C903.331 473.202 902.723 472.513 902.28 471.619C901.836 470.725 901.615 469.664 901.615 468.437C901.615 467.21 901.836 466.149 902.28 465.255C902.723 464.361 903.331 463.672 904.103 463.187C904.876 462.702 905.759 462.46 906.751 462.46C907.744 462.46 908.626 462.702 909.399 463.187C910.172 463.672 910.78 464.361 911.223 465.255C911.666 466.149 911.888 467.21 911.888 468.437ZM910.524 468.437C910.524 467.429 910.355 466.579 910.018 465.886C909.685 465.193 909.232 464.668 908.66 464.312C908.092 463.956 907.456 463.778 906.751 463.778C906.047 463.778 905.408 463.956 904.836 464.312C904.268 464.668 903.816 465.193 903.478 465.886C903.145 466.579 902.978 467.429 902.978 468.437C902.978 469.444 903.145 470.295 903.478 470.988C903.816 471.681 904.268 472.206 904.836 472.562C905.408 472.918 906.047 473.096 906.751 473.096C907.456 473.096 908.092 472.918 908.66 472.562C909.232 472.206 909.685 471.681 910.018 470.988C910.355 470.295 910.524 469.444 910.524 468.437ZM923.964 462.619V474.255H922.601L916.26 465.119H916.146V474.255H914.737V462.619H916.101L922.464 471.778H922.578V462.619H923.964ZM927.264 474.255V462.619H934.287V463.869H928.673V467.8H933.923V469.05H928.673V473.005H934.377V474.255H927.264ZM941.809 471.869V470.71L946.923 462.619H947.764V464.414H947.195L943.332 470.528V470.619H950.218V471.869H941.809ZM947.286 474.255V471.516V470.977V462.619H948.627V474.255H947.286Z",
    fill: "#2E3838"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 920.935,
    cy: 547.51,
    r: 25.3,
    stroke: "white",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 920.935,
    cy: 547.51,
    r: 38,
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 920.935,
    cy: 547.51,
    r: 13.65,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DZone4);
export default __webpack_public_path__ + "static/media/3d_zone_4.a6a5627f585f40602e9b73df2a485c90.svg";
export { ForwardRef as ReactComponent };